import Box from '@material-ui/core/Box';
import {makeStyles, Theme} from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import {Roles, SHOW_SPAC_FEATURES} from 'app/Constants';
import useRole from 'components/GenericsHooks/useRoles';
import {CollaboPage} from 'features/collaborator';
import {CoursePage} from 'features/course';
import {i18n2} from 'features/i18n/i18n';
import {StagePage} from 'features/instance';
import {ParameterPage} from 'features/parameter';
import {ProfCollaboratorPage} from 'features/profCollaborator';
import {ProfCoursePage} from 'features/profCourse';
import {ProfilesPage} from 'features/profile/';
import {ProfSpacPage} from 'features/profSpac';
import {ProfGralPage} from 'features/profGral';
import {RequirementPage} from 'features/requirement';
import {SectorsPage} from 'features/sectors';
import {SpacPage} from 'features/spac';
import {TurnPage} from 'features/turn';
import React from 'react';
import ProfGralSpacPage from 'features/profGralSpac/pages/profGralSpacPage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && <Box p={0}>{children}</Box>}
    </Typography>
  );
}

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1, // hara que el item se ajuste y tome todo el espacio disponible del eje
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'row',
    overflowX: 'hidden',
    overflowY: 'hidden',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'stretch',
    flexBasis: 'auto', //se define el tamaño de un item en terminos del espacio que deja como espacio disponible
    alignSelf: 'auto',
  },
  left: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    flex: '0 1 auto',
    height: '90vh',
    minWidth: '12%',
    margin: '10px',
  },
}));

export default function Pages() {
  const role: string = useRole();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const adminItpsTabs = React.useMemo(() => {
    const tabs = [
      {label: i18n2._('Cursos'), content: <CoursePage />},
      {label: i18n2._('Instancias'), content: <StagePage />},
      {label: i18n2._('Colaborador'), content: <CollaboPage />},
      {label: i18n2._('Sectores'), content: <SectorsPage />},
      {label: i18n2._('Perfiles'), content: <ProfilesPage />},
    ];

    if (SHOW_SPAC_FEATURES) {
      tabs.push(
        {label: i18n2._('SPAC'), content: <SpacPage />},
        {label: i18n2._('Perfil-Spac'), content: <ProfSpacPage />},
      );
    }

    if (SHOW_SPAC_FEATURES) {
      tabs.push(
        {label: i18n2._('Perfil-Curso'), content: <ProfCoursePage />},
        {
          label: i18n2._('Perfil-Colaborador'),
          content: <ProfCollaboratorPage />,
        },
      );
      tabs.push({label: i18n2._('Profile-General'), content: <ProfGralPage />});
      tabs.push({
        label: `${i18n2._('Profile-General')} - SPAC`,
        content: <ProfGralSpacPage />,
      });
    }

    tabs.push(
      {label: i18n2._('Turnos'), content: <TurnPage />},
      {label: i18n2._('Parametros'), content: <ParameterPage />},
    );

    return tabs;
  }, []);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  return (
    <div className={classes.root}>
      {role === Roles.AdminITPS ? (
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.left}>
          {adminItpsTabs.map((tab, index) => (
            <Tab key={`tab-${index}`} label={tab.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      ) : role === Roles.AdminQA || role === Roles.AdminHSE ? (
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.left}>
          <Tab label={i18n2._('Cursos')} {...a11yProps(0)} />
          <Tab label={i18n2._('Instancias')} {...a11yProps(1)} />
          <Tab label={i18n2._('Requerimientos')} {...a11yProps(2)} />
          {role === Roles.AdminQA ? (
            <Tab label={i18n2._('Sectores')} {...a11yProps(3)} />
          ) : null}
          {role === Roles.AdminQA ? (
            <Tab label={i18n2._('Colaborador')} {...a11yProps(4)} />
          ) : null}
          {role === Roles.AdminQA ? (
            <Tab label={i18n2._('Perfiles')} {...a11yProps(5)} />
          ) : null}
          {role === Roles.AdminQA ? (
            <Tab label={i18n2._('Turnos')} {...a11yProps(6)} />
          ) : null}
        </Tabs>
      ) : role === Roles.Trainer ? (
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.left}>
          <Tab label={i18n2._('Cursos')} {...a11yProps(0)} />
        </Tabs>
      ) : null}

      {role === Roles.AdminITPS ? (
        <div
          style={{
            flex: '1 1 auto',
            width: '100%',
            height: '100%',
            background: '#fafafa',
          }}>
          {adminItpsTabs.map((tab, index) => (
            <TabPanel key={`panel-${index}`} value={value} index={index}>
              {tab.content}
            </TabPanel>
          ))}
        </div>
      ) : role === Roles.AdminQA || role === Roles.AdminHSE ? (
        <div
          style={{
            flex: '1 1 auto',
            width: '100%',
            height: '100%',
            background: '#fafafa',
          }}>
          <TabPanel value={value} index={0}>
            <CoursePage />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <RequirementPage />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <StagePage />
          </TabPanel>
          {role === Roles.AdminQA ? (
            <TabPanel value={value} index={3}>
              <SectorsPage />
            </TabPanel>
          ) : null}

          {role === Roles.AdminQA ? (
            <TabPanel value={value} index={4}>
              <CollaboPage />
            </TabPanel>
          ) : null}

          {role === Roles.AdminQA ? (
            <TabPanel value={value} index={5}>
              <ProfilesPage />
            </TabPanel>
          ) : null}

          {role === Roles.AdminQA ? (
            <TabPanel value={value} index={6}>
              <TurnPage />
            </TabPanel>
          ) : null}
        </div>
      ) : null}

      {role === Roles.Trainer ? (
        <TabPanel value={value} index={0}>
          <CoursePage />
        </TabPanel>
      ) : null}
    </div>
  );
}
